import { render, staticRenderFns } from "./PerformanceCard.vue?vue&type=template&id=6f5b38fa&scoped=true"
import script from "./PerformanceCard.vue?vue&type=script&lang=js"
export * from "./PerformanceCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5b38fa",
  null
  
)

export default component.exports